import React, { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import AppBar from '@mui/material/AppBar';
import Container from '@mui/material/Container';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import IconButton from '@mui/material/IconButton';
import MenuIcon from '@mui/icons-material/Menu';
import Box from '@mui/material/Box';
import Avatar from '@mui/material/Avatar';
import Tooltip from '@mui/material/Tooltip';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import List from '@mui/material/List';
import Divider from '@mui/material/Divider';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import Drawer from '@mui/material/Drawer';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import DesignServicesIcon from '@mui/icons-material/DesignServices';
import EventNoteIcon from '@mui/icons-material/EventNote';
import UploadFileIcon from '@mui/icons-material/UploadFile';
import CardMembershipIcon from '@mui/icons-material/CardMembership';
import ContactPageIcon from '@mui/icons-material/ContactPage';
import ReportIcon from '@mui/icons-material/Report';
import ChecklistIcon from '@mui/icons-material/Checklist';
import HowToRegIcon from '@mui/icons-material/HowToReg';
import DoneAllIcon from '@mui/icons-material/DoneAll';
import CalculateIcon from '@mui/icons-material/Calculate';
import SolarPowerIcon from '@mui/icons-material/SolarPower';
import BatteryChargingFullIcon from '@mui/icons-material/BatteryChargingFull';
import AssignmentReturnIcon from '@mui/icons-material/AssignmentReturn';
import MiscellaneousServicesIcon from '@mui/icons-material/MiscellaneousServices';
import FormatListNumberedIcon from '@mui/icons-material/FormatListNumbered';
import PeopleIcon from '@mui/icons-material/People';
import Cookies from 'js-cookie';
import Button from '@mui/material/Button';
import AdminPanelSettingsIcon from '@mui/icons-material/AdminPanelSettings';
import ManageAccountsIcon from '@mui/icons-material/ManageAccounts';
import StorefrontIcon from '@mui/icons-material/Storefront';

const settings = ['Login'];

function Navbar({ isLoggedIn: propIsLoggedIn, isAppAdmin, isAppUser, isSuperAdmin }) {
  const [anchorElUser, setAnchorElUser] = useState(null);
  const [isLoggedIn, setIsLoggedIn] = useState(propIsLoggedIn);
  const [userData, setUserData] = useState({});
  const [openDrawer, setOpenDrawer] = useState(false);
  const navigate = useNavigate();
  const [adminMenuAnchorEl, setAdminMenuAnchorEl] = useState(null);

  useEffect(() => {
    setIsLoggedIn(propIsLoggedIn);
  }, [propIsLoggedIn]);

  const toggleDrawer = (open) => setOpenDrawer(open);

  const DrawerList = (
    <Box sx={{ width: 250 }} role="presentation" onClick={() => toggleDrawer(false)}>
      {/* Admin Accordion */}
      {(isSuperAdmin || isAppAdmin) && (
        <Accordion>
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            onClick={(event) => event.stopPropagation()}
          >
            <ListItemIcon><AdminPanelSettingsIcon /></ListItemIcon>
            <Typography>Admin</Typography>
          </AccordionSummary>
          <AccordionDetails>
            <List>
              <ListItem disablePadding component={Link} to="/user-management">
                <ListItemButton>
                  <ListItemIcon><ManageAccountsIcon /></ListItemIcon>
                  <ListItemText primary="User Management" primaryTypographyProps={{ color: 'primary' }} />
                </ListItemButton>
              </ListItem>
              {isSuperAdmin && (
                <ListItem disablePadding component={Link} to="/tenant-management">
                  <ListItemButton>
                    <ListItemIcon><StorefrontIcon /></ListItemIcon>
                    <ListItemText primary="Tenant Management" primaryTypographyProps={{ color: 'primary' }} />
                  </ListItemButton>
                </ListItem>
              )}
            </List>
          </AccordionDetails>
        </Accordion>
      )}
      
      {isLoggedIn && (
        <>
          {/* Membership Dropdown */}
          <Accordion>
            <AccordionSummary
              expandIcon={<ExpandMoreIcon />}
              onClick={(event) => event.stopPropagation()}
            >
              <ListItemIcon><PeopleIcon /></ListItemIcon>
              <Typography>Membership</Typography>
            </AccordionSummary>
            <AccordionDetails>
              <List>
                {/* Membership Management - visible to admin and worker */}
                {(isAppAdmin || isSuperAdmin) && (
                  <ListItem disablePadding component={Link} to="/membermgmt">
                    <ListItemButton>
                      <ListItemIcon><CardMembershipIcon /></ListItemIcon>
                      <ListItemText primary="Membership Management" />
                    </ListItemButton>
                  </ListItem>
                )}
                {/* Membership Form - visible to all logged in users */}
                <ListItem disablePadding component={Link} to="/addMemberForm">
                  <ListItemButton>
                    <ListItemIcon><ContactPageIcon /></ListItemIcon>
                    <ListItemText primary="Membership Form" />
                  </ListItemButton>
                </ListItem>
                {isAppAdmin && (
                  <ListItem disablePadding component={Link} to="/membership-data-upload">
                    <ListItemButton>
                      <ListItemIcon><UploadFileIcon /></ListItemIcon>
                      <ListItemText primary="Bulk Data Upload" />
                    </ListItemButton>
                  </ListItem>
                )}
                {isAppAdmin && (
                  <ListItem disablePadding component={Link} to="/membershipreports">
                    <ListItemButton>
                      <ListItemIcon><ReportIcon /></ListItemIcon>
                      <ListItemText primary="Reports" />
                    </ListItemButton>
                  </ListItem>
                )}
                {/* Membership Card - visible to all logged in users */}
                <ListItem disablePadding component={Link} to="/membership-card">
                  <ListItemButton>
                    <ListItemIcon><CardMembershipIcon /></ListItemIcon>
                    <ListItemText primary="Digital Membership Card" />
                  </ListItemButton>
                </ListItem>
              </List>
            </AccordionDetails>
          </Accordion>

          {/* Calendar Management */}
          <ListItem disablePadding component={Link} to="/appointment">
            <ListItemButton>
              <ListItemIcon><EventNoteIcon /></ListItemIcon>
              <ListItemText primary="Calendar Management" />
            </ListItemButton>
          </ListItem>

          {/* Checklist */}
          <Accordion>
            <AccordionSummary
              expandIcon={<ExpandMoreIcon />}
              onClick={(event) => event.stopPropagation()}
            >
              <ListItemIcon><ChecklistIcon /></ListItemIcon>
              <Typography>Checklist</Typography>
            </AccordionSummary>
            <AccordionDetails>
              <List>
                {isAppAdmin && (
                  <ListItem disablePadding>
                    <ListItemButton component={Link} to="/admin">
                      <ListItemIcon><HowToRegIcon /></ListItemIcon>
                      <ListItemText primary="Admin" />
                    </ListItemButton>
                  </ListItem>
                )}
                <ListItem disablePadding>
                  <ListItemButton component={Link} to="/user">
                    <ListItemIcon><DoneAllIcon /></ListItemIcon>
                    <ListItemText primary="User" />
                  </ListItemButton>
                </ListItem>
              </List>
            </AccordionDetails>
          </Accordion>

          {/* Calculator */}
          <Accordion>
            <AccordionSummary
              expandIcon={<ExpandMoreIcon />}
              onClick={(event) => event.stopPropagation()}
            >
              <ListItemIcon><CalculateIcon /></ListItemIcon>
              <Typography>Calculator</Typography>
            </AccordionSummary>
            <AccordionDetails>
              <List>
                {[
                  { name: 'Battery Calculator', icon: <BatteryChargingFullIcon /> },
                  { name: 'Solar Calculator', icon: <SolarPowerIcon /> },
                  { name: 'ROI Calculator', icon: <AssignmentReturnIcon /> }
                ].map((item, index) => (
                  <ListItem key={index} disablePadding>
                    <ListItemButton component={Link} to={`/${item.name.toLowerCase().replace(/\s+/g, '_')}`}>
                      <ListItemIcon>{item.icon}</ListItemIcon>
                      <ListItemText primary={item.name} />
                    </ListItemButton>
                  </ListItem>
                ))}
              </List>
            </AccordionDetails>
          </Accordion>

          {/* Services - visible to admin and worker */}
          {(isAppAdmin || isAppUser) && (
            <Accordion>
              <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                onClick={(event) => event.stopPropagation()}
              >
                <ListItemIcon><MiscellaneousServicesIcon /></ListItemIcon>
                <Typography>Services</Typography>
              </AccordionSummary>
              <AccordionDetails>
                <List>
                  {[
                    { name: 'services', icon: <MiscellaneousServicesIcon /> },
                    { name: 'service_list', icon: <FormatListNumberedIcon /> }
                  ].map((item, index) => (
                    <ListItem key={index} disablePadding>
                      <ListItemButton component={Link} to={`/${item.name.toLowerCase().replace(/\s+/g, '_')}`}>
                        <ListItemIcon>{item.icon}</ListItemIcon>
                        <ListItemText primary={item.name} />
                      </ListItemButton>
                    </ListItem>
                  ))}
                </List>
              </AccordionDetails>
            </Accordion>
          )}

          {/* More Apps Dropdown */}
          <Accordion>
            <AccordionSummary
              expandIcon={<ExpandMoreIcon />}
              onClick={(event) => event.stopPropagation()}
            >
              <ListItemIcon><DesignServicesIcon /></ListItemIcon>
              <Typography>More Apps</Typography>
            </AccordionSummary>
            <AccordionDetails>
              <List>
                {/* Business Cards */}
                <ListItem disablePadding component={Link} to={process.env.REACT_APP_PROFILE_LINK}>
                  <ListItemButton>
                    <ListItemIcon><EventNoteIcon /></ListItemIcon>
                    <ListItemText primary="Bussiness Cards" />
                  </ListItemButton>
                </ListItem>
                
                {/* Timer Management */}
                <ListItem disablePadding component={Link} to={process.env.REACT_APP_TIMER_MANAGEMENT_LINK}>
                  <ListItemButton>
                    <ListItemIcon><EventNoteIcon /></ListItemIcon>
                    <ListItemText primary="Timer Management" />
                  </ListItemButton>
                </ListItem>
                
                {/* Inventory Management */}
                <ListItem disablePadding component={Link} to={process.env.REACT_APP_INVENTORY_MANAGEMENT_LINK}>
                  <ListItemButton>
                    <ListItemIcon><EventNoteIcon /></ListItemIcon>
                    <ListItemText primary="Inventory Management" />
                  </ListItemButton>
                </ListItem>
                
                {/* Worranty Management (renamed from Warranty) */}
                <ListItem disablePadding component={Link} to={process.env.REACT_APP_WARRANTY_MANAGEMENT_LINK}>
                  <ListItemButton>
                    <ListItemIcon><EventNoteIcon /></ListItemIcon>
                    <ListItemText primary="Worranty Management" />
                  </ListItemButton>
                </ListItem>
                
                {/* Directory (new item) */}
                <ListItem disablePadding component={Link} to={process.env.REACT_APP_DIRECTORY_LINK}>
                  <ListItemButton>
                    <ListItemIcon><EventNoteIcon /></ListItemIcon>
                    <ListItemText primary="Directory" />
                  </ListItemButton>
                </ListItem>
              </List>
            </AccordionDetails>
          </Accordion>
        </>
      )}
  
      <Divider />
    </Box>
  );

  const handleOpenUserMenu = (event) => setAnchorElUser(event.currentTarget);
  const handleCloseUserMenu = () => setAnchorElUser(null);

  const handleLoginLogout = () => {
    if (isLoggedIn) {
      // Clear all authentication-related cookies
      Cookies.remove('jwtToken');
      Cookies.remove('userRole');
      Cookies.remove('isAppAdmin');
      Cookies.remove('isAppUser');
      Cookies.remove('userEmail');
      
      // Clear session storage
      sessionStorage.removeItem('jwtToken');
      
      // Reset local state
      setUserData({});
      setIsLoggedIn(false);
      
      // Navigate to home
      navigate('/home');
    } else {
      navigate('/login');
    }
  };

  const handleAdminMenuOpen = (event) => setAdminMenuAnchorEl(event.currentTarget);
  const handleAdminMenuClose = () => setAdminMenuAnchorEl(null);

  return (
    <AppBar position="static">
      <Container maxWidth="xl">
        <Toolbar disableGutters>
          {isLoggedIn &&(<IconButton
            size="large"
            edge="start"
            color="inherit"
            aria-label="menu"
            onClick={() => toggleDrawer(true)}
            sx={{ mr: 2, display: { xs: 'flex' } }}
          >
            <MenuIcon />
          </IconButton>)}
          <img src="/ReteLogo.png" alt="Rete Logo" style={{ height: 30, marginRight: 10 }} />
          <Typography
            variant="h6"
            noWrap
            component={Link}
            to="/"
            sx={{
              mr: 2,
              fontFamily: 'monospace',
              fontWeight: 700,
              letterSpacing: '.3rem',
              color: 'inherit',
              textDecoration: 'none',
            }}
          >
            OV RETAIL
          </Typography>
          <Drawer
            anchor="left"
            open={openDrawer}
            onClose={() => toggleDrawer(false)}
          >
            {DrawerList}
          </Drawer>
          
          <Box sx={{ flexGrow: 1 }} />

          <Box sx={{ mr: 2 }}>
            <Tooltip title="Open settings">
              <IconButton onClick={handleOpenUserMenu} sx={{ p: 0 }}>
                <Avatar alt={userData.displayName} src="/static/images/avatar/2.jpg" />
              </IconButton>
            </Tooltip>
            <Menu
              sx={{ mt: '45px' }}
              id="menu-appbar"
              anchorEl={anchorElUser}
              anchorOrigin={{
                vertical: 'top',
                horizontal: 'right',
              }}
              keepMounted
              transformOrigin={{
                vertical: 'top',
                horizontal: 'right',
              }}
              open={Boolean(anchorElUser)}
              onClose={handleCloseUserMenu}
            >
              {settings.map((setting, index) => (
                <MenuItem key={index} onClick={handleLoginLogout}>
                  <Typography textAlign="center">{isLoggedIn ? 'Logout' : 'Login'}</Typography>
                </MenuItem>
              ))}
            </Menu>
          </Box>
        </Toolbar>
      </Container>
    </AppBar>
  );
}

export default Navbar;
